import { isCharAlphaNumeric } from "@silevis/reactgrid";
import { KeyboardEvent } from "react";

export const stopKeyDownPropagation = (event: KeyboardEvent) => {
  if (isCharAlphaNumeric(event.key) || isKeyNavigation(event.key)) {
    event.stopPropagation();
  }
};

const isKeyNavigation = (key: string) => {
  return (
    // eslint-disable-next-line no-constant-binary-expression
    key === "ArrowUp" ||
    key === "ArrowDown" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    "Tab" ||
    "Backspace"
  );
};
